import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
} from '@angular/core';
import { DropDownInterval } from 'src/app/data-models/common/drop-down-interval.model';
import { LoggerService } from 'src/app/services/logger/logger.service';

@Component({
	selector: 'vtr-material-select',
	templateUrl: './material-select.component.html',
	styleUrls: ['./material-select.component.scss'],
})
export class MaterialSelectComponent implements OnInit, OnChanges {
	@Input() list: DropDownInterval[];
	@Input() value: number;
	@Input() id: string;
	@Input() header: string;
	@Input() disabled: boolean;
	@Input() notSelectedValue: { name?: string; text?: string; placeholder?: string };
	@Output() selectionChange: EventEmitter<any> = new EventEmitter<any>();

	name: string;
	placeholder: string;
	narratorLabel: string;
	selectedValue: number;
	applyHoverClass: boolean;
	applyFocusClass: boolean;

	constructor(private logger: LoggerService) {}

	ngOnInit() {
		this.setDropDownValue();
	}

	ngOnChanges(changes: SimpleChanges) {
		if (
			changes &&
			changes.value &&
			changes.value.previousValue !== changes.value.currentValue
		) {
			this.setDropDownValue();
		}
	}

	setDropDownValue() {
		if (this.value !== undefined && this.list) {
			const itemValue = this.list.find((item) => item.value === this.value);
			if (itemValue) {
				this.settingDimmerIntervals(itemValue);
			}
		} else {
			this.setDefaultDropValue();
		}
	}

	// sets 'select-time' or 'please-select'
	setDefaultDropValue() {
		this.name = this.notSelectedValue.name;
		this.placeholder = this.notSelectedValue.placeholder || this.notSelectedValue.text;
		this.narratorLabel = `${this.name}-${this.placeholder}`;
	}

	// refactoring duplicate lines of code for interval
	settingDimmerIntervals(interval) {
		this.selectedValue = this.list.indexOf(interval);
		this.name = interval.name;
		this.placeholder = interval.placeholder || interval.text;
		this.narratorLabel = interval.text;
	}

	closeDropdown(event) {
		try {
			const value = this.list.find((item, idx) => idx === event.value);
			// this.settingDimmerIntervals(value);
			this.selectionChange.emit(value);
		} catch (error) {
			this.logger.error('Error', error);
		}
	}
}
